import { useMachineSettingsDialogState } from 'components/sections/admin-portal/machines/hooks/useMachineSettingsDialogState';
import { MachineSettingsQueryParams } from 'enums/machine-settings';

export const useMachineLiveFiresDialogState = () => {
  const { getParams, setParams } = useMachineSettingsDialogState();

  const searchParams = getParams();

  // e.g. &fireID=123abc
  const fireID = searchParams.get(MachineSettingsQueryParams.FireID);

  const setFireID = (id: string) => {
    setParams(
      {
        [MachineSettingsQueryParams.FireID]: id,
      },
      'setFireID'
    );
  };

  const resetFireID = () => {
    setParams(
      {
        [MachineSettingsQueryParams.FireID]: undefined,
      },
      'resetFireID'
    );
  };

  return {
    fireID,
    setFireID,
    resetFireID,
  };
};
